import React from 'react'
import { parseFloatCurrency } from '../../../utils/formatting/floatnumberparsing'
import { getTotal, getSizeNumbers, getSizeEntries } from '../../../utils/tableparser'
import { RenderImage } from '../../images/ImageView'

/**
 * View for displaying the transaction order, 
 * @param {string} sizeCat the sizeCategory the displayed articleTypes are filtered after
 * @param {object[]} articleTypes array with article information, selected as transaction data
 * @param {any} removeOrderEntry removes a selected orderEntry
 * @param {boolean} isDeliveryOrder checks if the transaction type is a delivery or newArrivals
 * @param {any} setHasInvalidArticles hook to inform parent if transaction contains invalid article amounts
 */
const TransactionOrderView = ({ sizeCat, articleTypes, removeOrderEntry, isDeliveryOrder, setHasInvalidArticles }) => {

    /**
     * Checks whether the given order has invalid amounts in it
     * @param {object} transactionOrder object to be evaluated
     */
    const invalidAmount = (transactionOrder) => {
        let invalidAmounts = transactionOrder.sizeEntries.filter(x => x.Amount > x.AmountInStorage)

        if (invalidAmounts.length > 0) {
            setHasInvalidArticles(true)
            return true
        } else {
            setHasInvalidArticles(false)
            return false
        }
    }

    /**
     * Gets invalid amounts of a object
     * @param {object} transactionOrder object with invalid amounts
     */
    const getInvalidAmount = (transactionOrder) => {
        let invalidAmounts = transactionOrder.sizeEntries.filter(x => x.Amount > x.AmountInStorage)
                .map(x => ({ SizeValue: x.SizeValue, WrongAmount: x.Amount - x.AmountInStorage }))

        return invalidAmounts.map(x => <div>Größe {x.SizeValue} ist um {x.WrongAmount} zu hoch.</div>)
    }

    return (
        <>
            <thead className="sticky-table-header">
                <tr>
                    <th>{window.i18n('view')}</th>
                    <th>{window.i18n('articleNumberDesigner')}</th>
                    <th>{window.i18n('articleNumberFaex')}</th>
                    <th>{sizeCat}</th>
                    <th>{window.i18n('colour')}</th>
                    <th className="numberColumn">{window.i18n('salePriceAbb')}</th>
                    {getSizeEntries(articleTypes[0].sizeEntries)}
                    <th className="numberColumn">Total</th>
                </tr>
            </thead>

            <tbody>
                {articleTypes.map(entry =>
                    <>
                        <tr className={isDeliveryOrder ? invalidAmount(entry) ? "error" : "" : ""}>
                            <td>{RenderImage(entry.image)}</td>
                            <td>{entry.articleNumberDesigner}</td>
                            <td>{entry.articleIdFaex}</td>
                            <td>{entry.articleName}</td>
                            <td>{entry.colour}</td>
                            <td className="numberColumn">{parseFloatCurrency(entry.salePrice)}</td>
                            {getSizeNumbers(entry.sizeEntries)}
                            {getTotal(entry.sizeEntries)}
                            <td className="remove-order-td"><a className="remove-order" href=""
                                onClick={(event) => removeOrderEntry(event, sizeCat, entry)} variant="secondary">&#10060;</a></td>
                        </tr>
                        {invalidAmount(entry) &&
                            <tr className="error"><td colSpan="20">
                                {window.i18n('errorInvalidAmount1') + entry.articleName + window.i18n('errorInvalidAmount2')}
                                <br /> {getInvalidAmount(entry)}
                            </td></tr>}
                    </>
                )}
            </tbody>

        </>
    );
}

export { TransactionOrderView }